/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=884dadfc&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=884dadfc&lang=scss"

import exportComponent from "../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__